var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{class:_vm.fieldClass,attrs:{"id":_vm.fieldId,"name":_vm.fieldName,"placeholder":_vm.placeholderText,"rows":_vm.data.rows,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.sendEmit}},[_vm._v(" "+_vm._s(_vm.data.cssClass)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }